import React from "react";
import { FaFacebook, FaInstagram } from "react-icons/fa"; // Precisa instalar react-icons (npm install react-icons)
import "./Footer.css"; // Certificar-se de que o caminho para o CSS está correto
import logoFooter from "../../images/logo-footer.png"; // Certificar-se de que o caminho para a imagem está correto
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer id="footer">
      {/*Parte superior do footer*/}
      <div id="footer-top">
        {/*Logo*/}
        <a className="logo-footer" href="/" rel="next">
          <img src={logoFooter} alt="Logo Footer" />
        </a>

        {/*Links*/}
        <div className="footer-links">
          <Link className="footer-link" to="/">Sobre Nós</Link>
          <Link className="footer-link" to="/servicos">Serviços</Link>
          <Link className="footer-link" to="/contato">Contato</Link>
        </div>
      </div>

      {/*Linha divisória do footer*/}
      <div className="line"></div>

      {/*Parte inferior do footer*/}
      <div id="footer-bottom">
        {/* Redes sociais */}
        <div id="social-medias">
          <a
            href="https://www.facebook.com"
            aria-label="Facebook"
            className="social-medias"
          >
            <FaFacebook className="facebook-icon" />
          </a>
          <a
            href="https://www.instagram.com"
            aria-label="Instagram"
            className="social-medias"
          >
            <FaInstagram className="instagram-icon" />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
